export default "__VITE_ASSET__Bm3GpUHL__"